export default __webpack_public_path__ + "static/media/nonambulant.3769a099.svg";